import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { CONTACT, WHATSAPP_URL, TEL_URL } from "../data/site";

const NAV = [
    { label: "Ana Sayfa", to: "/#hero" },
    { label: "Hizmetler", to: "/#hizmetler" },
    { label: "Salonumuz", to: "/#hakkimizda" },
    { label: "Galeri", to: "/#galeri" },
    { label: "Yorumlar", to: "/#yorumlar" },
    { label: "İletişim", to: "/#iletisim" },
];

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);
    const loc = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        setOpen(false);
    }, [loc.pathname, loc.hash]);

    return (
        <>
            <header
                data-testid="site-header"
                className={`fixed top-0 inset-x-0 z-50 border-b transition-all duration-300 ${
                    scrolled
                        ? "header-shrink"
                        : "h-[80px] bg-[#0a0a0c]/50 backdrop-blur-md border-transparent"
                }`}
                style={{ height: scrolled ? 64 : 80 }}
            >
                <div className="container-x h-full flex items-center justify-between gap-6">
                    <Link
                        to="/"
                        data-testid="nav-logo"
                        className="flex items-center gap-3 shrink-0"
                    >
                        <div className="w-10 h-10 rounded-full overflow-hidden bg-black ring-1 ring-[#c9a24b]/45 shrink-0">
                            <img
                                src={CONTACT.logoUrl}
                                alt="Cegu Masaj"
                                className="w-full h-full object-cover logo-blend"
                                loading="eager"
                            />
                        </div>
                        <div className="hidden sm:flex flex-col leading-tight">
                            <span className="text-[15px] font-semibold gold-text tracking-tight">
                                Ce&Gu Masaj
                            </span>
                            <span className="text-[10px] uppercase tracking-[0.28em] text-[#7d766a] mt-0.5">
                                Özlüce · Bursa
                            </span>
                        </div>
                    </Link>

                    <nav className="hidden lg:flex items-center gap-8 mx-auto">
                        {NAV.map((n) => (
                            <a
                                key={n.to}
                                href={n.to}
                                data-testid={`nav-${n.label}`}
                                className="text-[13.5px] text-[#c9c2b3] hover:text-[#f5d685] transition-colors font-medium"
                            >
                                {n.label}
                            </a>
                        ))}
                    </nav>

                    <div className="flex items-center gap-3 shrink-0">
                        <a
                            href={TEL_URL}
                            data-testid="header-phone"
                            className="hidden md:inline-flex items-center gap-2 text-[13px] text-[#c9c2b3] hover:text-[#f5d685] transition font-medium"
                        >
                            <Phone className="w-4 h-4 text-[#c9a24b]" />
                            {CONTACT.phone}
                        </a>
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="header-cta"
                            className="btn btn-gold !text-[12px] !py-2 !px-4 !min-h-0"
                        >
                            Randevu Al
                        </a>
                        <button
                            onClick={() => setOpen(true)}
                            data-testid="mobile-menu-toggle"
                            aria-label="Menü aç"
                            className="lg:hidden w-10 h-10 rounded-full border border-[#c9a24b]/30 flex items-center justify-center text-[#f5d685]"
                        >
                            <Menu className="w-5 h-5" />
                        </button>
                    </div>
                </div>
            </header>

            {open && (
                <div
                    className="fixed inset-0 z-[60] bg-[#0a0a0c]/97 backdrop-blur-2xl lg:hidden"
                    data-testid="mobile-menu"
                >
                    <div className="container-x flex justify-between items-center h-[64px]">
                        <span className="text-[15px] font-semibold gold-text">
                            Menü
                        </span>
                        <button
                            onClick={() => setOpen(false)}
                            data-testid="mobile-menu-close"
                            aria-label="Menü kapat"
                            className="w-10 h-10 rounded-full border border-[#c9a24b]/30 flex items-center justify-center text-[#f5d685]"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </div>
                    <nav className="container-x mt-8 flex flex-col divide-y divide-[#23232b]">
                        {NAV.map((n) => (
                            <a
                                key={n.to}
                                href={n.to}
                                onClick={() => setOpen(false)}
                                className="py-4 text-[18px] font-medium text-[#f4efe4]"
                            >
                                {n.label}
                            </a>
                        ))}
                    </nav>
                    <div className="container-x mt-8 flex flex-col gap-3">
                        <a href={WHATSAPP_URL} className="btn btn-gold w-full">
                            WhatsApp'tan Randevu
                        </a>
                        <a href={TEL_URL} className="btn btn-ghost w-full">
                            <Phone className="w-4 h-4" /> {CONTACT.phone}
                        </a>
                    </div>
                </div>
            )}
        </>
    );
}
